'use client';

import { useEffect } from 'react';
import fetchIntercept from 'fetch-intercept';
import { getContainer } from '@framework/di/getContainer';
import registerMessagesExecCallback from '@framework/message/registerMessagesExecCallback';
import { checkSession } from '@users/session/interceptors/fetch/checkSession';

function BootstrapClientGlobalListeners() {
  const container = getContainer();
  useEffect(() => {
    // @ts-ignore
    fetchIntercept.register({ response: checkSession(container) });
    registerMessagesExecCallback(container);
  }, []);

  return null;
}

export default BootstrapClientGlobalListeners;
